import * as ApiModels from '@typings/api-models';
import { SendMessageActionData } from '@components/CreateEditSendMessageActionForm/CreateEditSendMessageActionForm';

type ThisWorkflowStep = Pick<ApiModels.WorkflowStep, 'id' | 'data'>;

const isDocumentRequestTemplate = (step: ThisWorkflowStep | null): boolean => {
  if (!step) {
    return false;
  }
  const data = step.data as SendMessageActionData;

  return Boolean(data?.message?.attachments?.find((a) => (
    a.referenceType === ApiModels.MESSAGE_ATTACHMENT_REFERENCE_TYPES.DOCUMENT_REQUEST_TEMPLATE),
  ));
};

const isFormTemplate = (step: ThisWorkflowStep | null): boolean => {
  if (!step) {
    return false;
  }
  const data = step.data as SendMessageActionData;

  return Boolean(data?.message?.attachments?.find((a) => (
    a.referenceType === ApiModels.MESSAGE_ATTACHMENT_REFERENCE_TYPES.FORM_REQUEST_TEMPLATE),
  ));
};

const getAvailableTriggers = <S extends ThisWorkflowStep>({
  step,
  workflow,
}: {
  step: S;
  workflow: { steps: Array<S> };
 }): ApiModels.WORKFLOW_TRIGGERS[] => {
  const availableTriggers = [ApiModels.WORKFLOW_TRIGGERS.PRODUCT_PURCHASED, ApiModels.WORKFLOW_TRIGGERS.PURCHASE_INITIATED];
  const stepIndex = workflow.steps.indexOf(step);
  const previousStep = workflow.steps[stepIndex - 1] || null;
  if (isDocumentRequestTemplate(previousStep)) {
    availableTriggers.push(ApiModels.WORKFLOW_TRIGGERS.DOCUMENTS_UPLOADED);
  }
  if (isFormTemplate(previousStep)) {
    availableTriggers.push(ApiModels.WORKFLOW_TRIGGERS.FORM_REQUEST_COMPLETED);
  }
  return availableTriggers;
};

export default getAvailableTriggers;
